var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 26.5651 26.4961",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    filter: "url(#filter0_d_0_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3255 20.6045H13.3221C11.7949 20.6039 10.2971 20.1971 8.99041 19.4279L8.67962 19.2449L5.45851 20.0831L6.3183 16.968L6.1159 16.6487C5.26399 15.3046 4.81405 13.7512 4.81469 12.1561C4.81656 7.50179 8.63447 3.71516 13.3289 3.71516C15.6021 3.71604 17.739 4.59527 19.3458 6.19083C20.9527 7.78644 21.8371 9.90739 21.8362 12.163C21.8343 16.8177 18.0164 20.6045 13.3255 20.6045Z",
    fill: "url(#paint0_linear_0_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9939 14.2823C17.738 14.1553 16.4802 13.5413 16.2456 13.4566C16.0111 13.372 15.8406 13.3296 15.67 13.5837C15.4994 13.8377 15.0091 14.4093 14.8598 14.5787C14.7106 14.748 14.5614 14.7693 14.3055 14.6422C14.0497 14.5152 13.2253 14.2472 12.2481 13.3826C11.4875 12.7098 10.974 11.8787 10.8247 11.6246C10.6755 11.3705 10.8089 11.2332 10.937 11.1067C11.052 10.993 11.1928 10.8103 11.3207 10.6621C11.4486 10.5139 11.4913 10.4081 11.5766 10.2387C11.6619 10.0693 11.6192 9.92114 11.5552 9.79411C11.4913 9.66709 10.9796 8.418 10.7664 7.9099C10.5588 7.41507 10.3478 7.48202 10.1908 7.47426C10.0417 7.46689 9.87096 7.46533 9.70039 7.46533C9.52982 7.46533 9.25267 7.52887 9.01811 7.78287C8.7836 8.03692 8.12267 8.65092 8.12267 9.89996C8.12267 11.149 9.03946 12.3558 9.16739 12.5252C9.29531 12.6945 10.9715 15.2578 13.538 16.357C14.1484 16.6185 14.625 16.7746 14.9966 16.8916C15.6095 17.0847 16.1673 17.0575 16.6081 16.9922C17.0996 16.9193 18.1218 16.3782 18.335 15.7854C18.5482 15.1927 18.5482 14.6845 18.4843 14.5787C18.4203 14.4729 18.2498 14.4093 17.9939 14.2823M13.3255 20.6045H13.3221C11.7949 20.6039 10.2971 20.197 8.99041 19.4279L8.67962 19.2449L5.45851 20.083L6.3183 16.968L6.1159 16.6486C5.26399 15.3046 4.81405 13.7511 4.81469 12.1561C4.81656 7.50177 8.63447 3.71514 13.3289 3.71514C15.6021 3.71602 17.739 4.59525 19.3458 6.19081C20.9527 7.78642 21.8371 9.90737 21.8362 12.1629C21.8343 16.8176 18.0164 20.6045 13.3255 20.6045M20.5688 4.97855C18.6355 3.05881 16.0646 2.00107 13.3254 2C7.68158 2 3.08814 6.55582 3.08588 12.1557C3.08514 13.9457 3.55662 15.693 4.45265 17.2331L3 22.4961L8.42814 21.0839C9.92373 21.893 11.6076 22.3193 13.3214 22.3201H13.3255H13.3256C18.9689 22.3201 23.5627 17.7637 23.5651 12.1638C23.5661 9.45 22.502 6.89825 20.5688 4.97855",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_5",
    x: 0,
    y: -4.74101e-8,
    width: 26.5651,
    height: 26.4961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5",
    x1: 13.3254,
    y1: 20.6045,
    x2: 13.3254,
    y2: 3.71516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FFB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28D146"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.9066a5cad90278d47c90eddcda4e979a.svg";
export { ForwardRef as ReactComponent };